// Country dial codes for the phone field. Flags are derived from the ISO code
// (regional-indicator code points), so no image assets are needed.

export interface Country {
  iso: string; // ISO 3166-1 alpha-2
  name: string;
  dial: string; // e.g. "+90"
}

export const countryFlag = (iso: string): string =>
  iso
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

export const COUNTRIES: Country[] = [
  { iso: 'US', name: 'United States', dial: '+1' },
  { iso: 'GB', name: 'United Kingdom', dial: '+44' },
  { iso: 'TR', name: 'Türkiye', dial: '+90' },
  { iso: 'RU', name: 'Russia', dial: '+7' },
  { iso: 'HK', name: 'Hong Kong', dial: '+852' },
  { iso: 'AM', name: 'Armenia', dial: '+374' },
  { iso: 'PH', name: 'Philippines', dial: '+63' },
  { iso: 'DE', name: 'Germany', dial: '+49' },
  { iso: 'FR', name: 'France', dial: '+33' },
  { iso: 'IT', name: 'Italy', dial: '+39' },
  { iso: 'ES', name: 'Spain', dial: '+34' },
  { iso: 'NL', name: 'Netherlands', dial: '+31' },
  { iso: 'PT', name: 'Portugal', dial: '+351' },
  { iso: 'PL', name: 'Poland', dial: '+48' },
  { iso: 'UA', name: 'Ukraine', dial: '+380' },
  { iso: 'GE', name: 'Georgia', dial: '+995' },
  { iso: 'AZ', name: 'Azerbaijan', dial: '+994' },
  { iso: 'KZ', name: 'Kazakhstan', dial: '+7' },
  { iso: 'AE', name: 'United Arab Emirates', dial: '+971' },
  { iso: 'SA', name: 'Saudi Arabia', dial: '+966' },
  { iso: 'QA', name: 'Qatar', dial: '+974' },
  { iso: 'IL', name: 'Israel', dial: '+972' },
  { iso: 'IN', name: 'India', dial: '+91' },
  { iso: 'PK', name: 'Pakistan', dial: '+92' },
  { iso: 'BD', name: 'Bangladesh', dial: '+880' },
  { iso: 'ID', name: 'Indonesia', dial: '+62' },
  { iso: 'MY', name: 'Malaysia', dial: '+60' },
  { iso: 'SG', name: 'Singapore', dial: '+65' },
  { iso: 'TH', name: 'Thailand', dial: '+66' },
  { iso: 'VN', name: 'Vietnam', dial: '+84' },
  { iso: 'CN', name: 'China', dial: '+86' },
  { iso: 'JP', name: 'Japan', dial: '+81' },
  { iso: 'KR', name: 'South Korea', dial: '+82' },
  { iso: 'TW', name: 'Taiwan', dial: '+886' },
  { iso: 'AU', name: 'Australia', dial: '+61' },
  { iso: 'NZ', name: 'New Zealand', dial: '+64' },
  { iso: 'CA', name: 'Canada', dial: '+1' },
  { iso: 'MX', name: 'Mexico', dial: '+52' },
  { iso: 'BR', name: 'Brazil', dial: '+55' },
  { iso: 'AR', name: 'Argentina', dial: '+54' },
  { iso: 'CL', name: 'Chile', dial: '+56' },
  { iso: 'CO', name: 'Colombia', dial: '+57' },
  { iso: 'PE', name: 'Peru', dial: '+51' },
  { iso: 'ZA', name: 'South Africa', dial: '+27' },
  { iso: 'NG', name: 'Nigeria', dial: '+234' },
  { iso: 'EG', name: 'Egypt', dial: '+20' },
  { iso: 'KE', name: 'Kenya', dial: '+254' },
  { iso: 'MA', name: 'Morocco', dial: '+212' },
  { iso: 'IE', name: 'Ireland', dial: '+353' },
  { iso: 'BE', name: 'Belgium', dial: '+32' },
  { iso: 'CH', name: 'Switzerland', dial: '+41' },
  { iso: 'AT', name: 'Austria', dial: '+43' },
  { iso: 'SE', name: 'Sweden', dial: '+46' },
  { iso: 'NO', name: 'Norway', dial: '+47' },
  { iso: 'DK', name: 'Denmark', dial: '+45' },
  { iso: 'FI', name: 'Finland', dial: '+358' },
  { iso: 'CZ', name: 'Czechia', dial: '+420' },
  { iso: 'GR', name: 'Greece', dial: '+30' },
  { iso: 'RO', name: 'Romania', dial: '+40' },
  { iso: 'HU', name: 'Hungary', dial: '+36' },
  { iso: 'BG', name: 'Bulgaria', dial: '+359' },
  { iso: 'RS', name: 'Serbia', dial: '+381' },
  { iso: 'HR', name: 'Croatia', dial: '+385' },
  { iso: 'SK', name: 'Slovakia', dial: '+421' },
  { iso: 'LT', name: 'Lithuania', dial: '+370' },
  { iso: 'LV', name: 'Latvia', dial: '+371' },
  { iso: 'EE', name: 'Estonia', dial: '+372' },
  { iso: 'UZ', name: 'Uzbekistan', dial: '+998' },
  { iso: 'KG', name: 'Kyrgyzstan', dial: '+996' },
  { iso: 'BY', name: 'Belarus', dial: '+375' },
  { iso: 'MD', name: 'Moldova', dial: '+373' },
];
